import React, { Component } from 'react';
import FilterBasic from '../../basicElement/FilterBasic';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import dictCache from '../../../common/dictCache';
import { Button } from 'antd';


class Filter extends Component {

    state = {
        areaList: [],
        stageList: [],
        businessList: [],
    }

    componentDidMount() {
        this.loadTypeConfigureList();
        this.queryBusiness();
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.typeConfigureList,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({
                areaList: res.areaList,
                stageList: res.stageList,
            });
        });
    }

     //获取业务线选项
    queryBusiness = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    handleChange = (params, key) => {
        this.props.onChange(params, key);
    }
    
    render() {
        const { searchParams, search, exportData, batchMark, statusList } = this.props;
        const { areaList, stageList, businessList } = this.state;
        const areaOption = areaList.map(el => ({ value: el.investigationAreaId, label: el.investigationAreaName }));
        const stageOption = stageList.map(el => ({ value: el.typeConfigureId, label: el.typeValue }));
        const businessOption = businessList.map(el => ({ value: el.typeConfigureId, label: el.typeValue }));
        const filters = [{
            name: '报销单号',
            key: 'reimbursementNum',
            type: 'input',
        }, {
            name: '项目简称',
            key: 'investigation',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'investigationName',
                style: {width: 160},
                placeholder: '输入名称检索',
                params: {limit: 20},
                url: API_URL.investigation.queryInvestigationByName,
                config: { id: 'investigationId', name: 'investigationName' }
            }
        }, {
            name: 'JDE项目号',
            key: 'jdeCode',
            type: 'input',
        }, {
            name: 'JDE主项目号',
            key: 'jdeMainCode',
            type: 'input',
        }, {
            name: '项目阶段',
            key: 'stageIds',
            type: 'select',
            typeProperty: {
                style: { width: 140 },
                mode: 'multiple',
                list: stageOption,
            }
        }, {
            name: '客户名称',
            key: 'customerCompany',
            type: 'searchMulRetrieve',
            typeProperty: {
                keyword: 'customerCompanyName',
                style: { width: 160 },
                placeholder: '输入客户名称检索',
                params: { limit: 20 },
                url: API_URL.investigation.queryCustomerCompanyByName,
                config: { id: 'customerCompanyId', name: 'customerCompanyName' }
            }
        }, {
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption,
            }
        }, {
            name: '状态',
            key: 'ptPriceStatus',
            type: 'select',
            typeProperty: {
                list: statusList,
            }
        }, {
            name: 'PM',
            key: 'pmUser',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.investigation.queryUserByKey,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '客户CSA',
            key: 'csaUser',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.investigation.queryUserByKey,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '项目领域',
            key: 'investigationAreaId',
            type: 'select',
            typeProperty: {
                showSearch: true,
                style: { width: 140 },
                placeholder: '输入名称检索',
                filterOption: (input, option) => {
                    return option.props.children.props.children.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                },
                list: areaOption,
            }
        }, {
            name: '领域leader',
            key: 'tal',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: { width: 140 },
                placeholder: '输入姓名/工号检索',
                params: { limit: 20 },
                url: API_URL.user.queryLeaderList,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '报销审批完成时间',
            key: 'approvalCompletionDate',
            type: 'rangePicker',
            typeProperty: {
                style: { width: 180 },
                keys: ['beginDate', 'endDate'],
            }
        },];
        
        const buttons = [
            <Button key="export" type="primary" onClick={exportData}>导出</Button>,
            <Button key="batchMark" type="primary" onClick={batchMark}>批量标记</Button>,
        ]

        return (
            <FilterBasic 
                search={search} 
                filters={filters} 
                params={searchParams} 
                onChange={this.handleChange} 
                buttons={buttons}
            />
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/contractManagement/ptReimburse/Filter.js